import imagesLoaded from 'imagesloaded'

export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    return {
      provide: {
        imagesLoaded,
      },
    };
  }
})